import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
// 아이콘: 사이트에서 쓰는 Remix Icon 만 담은 경량 글꼴 (scripts/build-icons.mjs 가 빌드 때 생성)
import './styles/remixicon-subset.css'
import './index.css'
import App from './App.tsx'

const root = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

// 배포본은 scripts/prerender.mjs 가 만든 정적 HTML 이 #root 에 이미 들어 있으므로 hydrate 합니다.
// 개발 서버(비어 있는 #root)에서는 일반 렌더링.
if (root.hasChildNodes()) {
  hydrateRoot(root, app)
} else {
  createRoot(root).render(app)
}
